<template>
  <div>
    <header-title
      title="حملات التبرع"
      titlePrevious="الرئيسية"
      color="#048042 "
    />
    <div class="container">
      <div class="filter_small_screen_filter">
        <div class="filter_small_screen campaign">
          <collapse-header title_img="filter" title="بحث بحسب">
            <form-autocomplete
              label="اسم الحملة"
              v-model="nameCampaign"
              :getOptionLabel="(x) => x.name_ar"
              :reduce="(x) => x.id"
              filterKey="name"
              ep="v2/guest/campaign-names"
              id="campaign_donation"
              placeholder="ابدأ بالكتابة للبحث"
            />
            <form-select
              label="الفئة المستهدفة"
              v-model="ageCategory"
              :dir="'rtl'"
              :getOptionLabel="(x) => x.name_ar"
              :reduce="(x) => x.id"
              id="selectedCategories_donation"
              ep="v2/guest/selects/age-categories"
            />
            <form-autocomplete
              label="المنظمة"
              :dir="'rtl'"
              :getOptionLabel="(x) => x.name_ar"
              :reduce="(x) => x.id"
              ep="v2/guest/filter-name"
              id="ngos"
              v-model="selectedOrg"
              filterKey="name"
              placeholder="ابدأ بالكتابة للبحث"
            />
            <div class="mb-1">
              <span class="type_donations">نوع التبرع</span>

              <v-select
                v-model="selected"
                dir="rtl"
                label="title"
                :options="option"
              />
            </div>
            <form-select
              label="المحافظة"
              v-model="selectedGovernorate"
              :getOptionLabel="(x) => x.name_ar"
              :reduce="(x) => x.id"
              id="sgovernorate"
              ep="v2/guest/selects/governorates"
            />
            <div class="row px-1 d-flex justify-content-between">
              <b-button variant="primary" @click="unFilter()"
                >إلغاء البحث</b-button
              >
              <b-button variant="info" @click="filtered()">بحث</b-button>
            </div>
          </collapse-header>
        </div>
      </div>
      <div class="row">
        <div class="sidebar col-lg-3">
          <!--Widget Start-->

          <basc-card style="max-width: 310px; min-height: 500px">
            <div class="d-flex align-item-center">
              <feather-icon icon="FilterIcon" size="17" class="mx-25" />
              <h6>بحث بحسب</h6>
            </div>
            <div>
              <hr />
            </div>
            <form-autocomplete
              label="اسم الحملة"
              v-model="nameCampaign"
              :getOptionLabel="(x) => x.name_ar"
              :reduce="(x) => x.id"
              filterKey="name"
              ep="v2/guest/campaign-names"
              id="campaign_donation"
              placeholder="ابدأ بالكتابة للبحث"
            />
            <form-select
              label="الفئة المستهدفة"
              v-model="ageCategory"
              :dir="'rtl'"
              :getOptionLabel="(x) => x.name_ar"
              :reduce="(x) => x.id"
              id="selectedCategories_donation"
              ep="v2/guest/selects/age-categories"
            />
            <form-autocomplete
              label="المنظمة"
              :dir="'rtl'"
              :getOptionLabel="(x) => x.name_ar"
              :reduce="(x) => x.id"
              ep="v2/guest/filter-name"
              id="ngos"
              v-model="selectedOrg"
              filterKey="name"
              placeholder="ابدأ بالكتابة للبحث"
            />
            <div class="mb-1">
              <span class="type_donations">نوع التبرع</span>

              <v-select
                v-model="selected"
                dir="rtl"
                label="title"
                :options="option"
              />
            </div>
            <form-select
              label="المحافظة"
              v-model="selectedGovernorate"
              :getOptionLabel="(x) => x.name_ar"
              :reduce="(x) => x.id"
              id="sgovernorate"
              ep="v2/guest/selects/governorates"
            />
            <div class="row px-1 d-flex justify-content-between">
              <b-button variant="primary" @click="unFilter()"
                >إلغاء البحث</b-button
              >
              <b-button variant="info" @click="filtered()">بحث</b-button>
            </div>
          </basc-card>
        </div>
        <div v-if="loading" class="col-lg-9 mt-1">
          <div class="d-flex">
            <BSkeleton width="150px" height="40px"> </BSkeleton>
            <BSkeleton width="150px" height="40px" class="mx-2"> </BSkeleton>
          </div>
          <!-- <hr class="mb-2 mt-0"/> -->

          <div v-if="loading" class="row w-100">
            <Skeleton class="col-md-6 col-12" v-for="n in 2" :key="n">
            </Skeleton>
          </div>
        </div>
        <div v-else class="col-lg-9 mt-1">
          <div class="d-flex">
            <div
              class="button_tap"
              v-for="item in bitton_tap"
              :key="item.id"
              :class="{ active_button_tap: item.id == active_button }"
              @click="active_button = item.id"
            >
              {{ item.name }}
            </div>
          </div>
          <hr class="mb-2 mt-0" />

          <alert
            v-if="campaigns.length === 0"
            class="col-lg-12 mt-1 w-100"
            :massage="$t('alert')"
          ></alert>

          <b-row v-else>
            <b-col
              cols="12"
              lg="6"
              md="6"
              v-for="(item, i) in campaigns"
              :key="i"
            >
              <card-donation :item="item"></card-donation>
            </b-col>
          </b-row>
          <pagination
            v-if="pagination.total_row"
            v-model="currentPage"
            :total-rows.sync="pagination.total_row"
            :per-page.sync="pagination.per_page"
            align="center"
          >
          </pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderTitle from "../../components/HeaderTitle.vue";
import CardDonation from "../../components/CardDonation.vue";
import vSelect from "vue-select";
import {
  BCard,
  BButton,
  BProgress,
  BProgressBar,
  BInputGroup,
  BFormInput,
  BPaginationNav,
  BRow,
  BCol,
  BContainer,
  BSkeleton,
} from "bootstrap-vue";
import FormSelect from "@/components/form-select";
import BascCard from "../../components/BascCard.vue";
import formAutocomplete from "@/components/form-autocomplete";
import { mapGetters } from "vuex";
import Alert from "../../../../components/Alert.vue";
import Pagination from "@/components/pagination/index.vue";
import CollapseHeader from "@/@core/components/app-collapse/CollapseHeader.vue";
import Skeleton from "../../components/Skeleton.vue";
export default {
  components: {
    BRow,
    BCol,
    HeaderTitle,
    CardDonation,
    BCard,
    BButton,
    BProgress,
    BProgressBar,
    FormSelect,
    BascCard,
    BInputGroup,
    BFormInput,
    formAutocomplete,
    Alert,
    Pagination,
    CollapseHeader,
    Skeleton,
    vSelect,
    BPaginationNav,
    BContainer,
    BSkeleton,
  },

  data() {
    return {
      currentPage: 1,
      selectedOrg: "",
      nameCampaign: "",
      selectedGovernorate: null,
      ageCategory: "",
      selected: null,
      option: [
        { value: 1, title: "مادي" },
        { value: 0, title: "عيني" },
      ],
      active_button: 2,
      bitton_tap: [
        { name: "حملات التبرع", id: 2 },
        { name: "حملات التبرع السابقة", id: 3 },
      ],
    };
  },
  watch: {
    currentPage(value) {
      this.$store.dispatch(`NgoHome/donation/getCampaigns`, {
        type: this.active_button == 2 ? "active" : "inactive",
        data: {
          page: value,
          campaign_id: this.nameCampaign,
          age_category_id: this.ageCategory,
          ngo_id: this.selectedOrg,
          campaign_type: this.selected ? this.selected.value : null,
          governorate_id: this.selectedGovernorate,
        },
      });
    },
    active_button() {
      this.submitEvent();
    },
  },
  methods: {
    unFilter() {
      this.selected = "";
      this.currentPage = 1;
      this.selectedOrg = "";
      this.nameCampaign = "";
      this.selectedGovernorate = "";
      this.ageCategory = "";
      this.$store.dispatch(`NgoHome/donation/getCampaigns`, {
        type: this.active_button == 2 ? "active" : "inactive",
        data: {
          campaign_id: this.nameCampaign,
          age_category_id: this.ageCategory,
          ngo_id: this.selectedOrg,
          campaign_type: this.selected ? this.selected.value : null,
          governorate_id: this.selectedGovernorate,
        },
      });
    },
    filtered() {
      this.$store.dispatch(`NgoHome/donation/getCampaigns`, {
        type: this.active_button == 2 ? "active" : "inactive",
        data: {
          campaign_id: this.nameCampaign,
          age_category_id: this.ageCategory,
          ngo_id: this.selectedOrg,
          campaign_type: this.selected ? this.selected.value : null,
          governorate_id: this.selectedGovernorate,
        },
      });
    },
    submitEvent() {
      if (this.active_button == 2) {
        this.$store.dispatch(`NgoHome/donation/getCampaigns`, {
          page: this.currentPage,
          type: "active",
        });
      } else if (this.active_button == 3) {
        this.$store.dispatch(`NgoHome/donation/getCampaigns`, {
          page: this.currentPage,
          type: "inactive",
        });
      }
    },
  },
  computed: {
    ...mapGetters("NgoHome/donation", ["campaigns", "loading", "pagination"]),
  },
  created() {
    this.$store.dispatch(`NgoHome/donation/getCampaigns`, { type: "active" });
  },
};
</script>
<style lang="scss">
.filter_small_screen_filter {
  // .filter_small_screen {
  .card-header.collapsed {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
    padding-left: 0px !important;
  }
  // }
}
.type_donations {
  font-size: 0.857rem;
  color: #5e5873;
}
.button_tap {
  border: 1px solid #048042;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding-top: 7px;
  padding-bottom: 7px;
  max-width: 150px;
  cursor: pointer;
  margin-top: 10px;
  margin-right: 10px;
  width: 150px;
  text-align: center;
  transition: all 0.3s ease;

  &:hover {
    background: #0e569642;
  }
}
.active_button_tap {
  background: #048042;
  color: #eee;
  transition: all 0.3s ease;
}
.filter_small_screen {
  display: none;
}
@media (max-width: 1030px) {
  .sidebar {
    display: none;
  }
  .filter_small_screen {
    display: block;
  }
}
</style>
